import { isProd } from "@helper/utils";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

export type UserInfoType = {
  allow: string;
  aud: string;
  auth_time: number;
  cid: string;
  exp: number;
  firstname: string;
  hashid: string;
  iat: number;
  iss: string;
  jti: string;
  lastname: string;
  loginId: string;
  scp: Array<string>;
  sessionid: string;
  sub: string;
  svc: Array<string>;
  uid: string;
  ver: number;
} | null;

const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState<UserInfoType>(null);
  const [userError, setUserError] = useState<unknown>(null);

  const handleLoadUserInfo = () => {
    try {
      /* eslint-disable  @typescript-eslint/no-unsafe-assignment */
      const token =
        /* eslint-disable  @typescript-eslint/no-unsafe-member-access */
        JSON.parse(
          /* eslint-disable  @typescript-eslint/no-unsafe-assignment */
          window.localStorage.getItem("okta-token-storage") as string,
        )?.accessToken;

      /* eslint-disable  @typescript-eslint/no-unsafe-argument */
      setUserInfo(jwtDecode(token?.accessToken));
    } catch (error) {
      setUserError(error);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined" && !isProd) {
      handleLoadUserInfo();
      window.addEventListener("storage", handleLoadUserInfo);
    }

    return () => {
      if (typeof window !== "undefined" && !isProd) {
        window.removeEventListener("storage", handleLoadUserInfo);
      }
    };
  }, []);

  return {
    userInfo,
    userError,
  };
};

export { useUserInfo };
